export default "__VITE_ASSET__5f891f15__"